// @ai-generated 2026-08-21T06:10:42+00:00 by kai.cissarek@synqony.com using Claude Opus 5
import { type Column, type LinkableField, renderDateTime } from '@synqo/frontend-component-library';
import { type ContainerStockGroup, type ContainerStockRow } from './containerStockGroups';
import { renderDaysStanding, STANDING_FOR } from './standingFor';

/** What the columns that both a group and a single line have read off their row. */
type StockRowLike = ContainerStockGroup | ContainerStockRow;

const dash = (text: string) => <>{text || '—'}</>;

const containerTypeColumn: Readonly<Column<StockRowLike>> = {
    name: 'container_type.display_string',
    label: 'Containertyp',
};

const countColumn: Readonly<Column<ContainerStockGroup>> = {
    name: 'count',
    label: 'Anzahl',
    disableColumnFilter: true,
    disableColumnSort: true,
};

const billedAsColumn: Readonly<Column<ContainerStockRow>> = {
    name: 'billed_as.display_string',
    label: 'Abgerechnet als',
};

const containerNumberColumn: Readonly<Column<StockRowLike>> = {
    name: 'container.display_string',
    label: 'Nummer',
    renderCell: ({ rowData }) => dash(rowData.container.display_string),
};

const contentColumn: Readonly<Column<StockRowLike>> = {
    name: 'content.display_string',
    label: 'Inhalt',
    renderCell: ({ rowData }) => dash(rowData.content.display_string),
};

const siteColumn: Readonly<Column<StockRowLike>> = { name: 'site.display_string', label: 'Standort' };

const standingSinceColumn: Readonly<Column<StockRowLike>> = {
    name: 'standing_since',
    label: 'Steht seit',
    type: 'datetime',
    renderCell: ({ rowData }) => renderDateTime(rowData.standing_since, 'date'),
};

const standingForColumn: Readonly<Column<StockRowLike>> = {
    name: STANDING_FOR,
    label: 'Dauer',
    renderCell: ({ rowData }) => renderDaysStanding(rowData.standing_since, new Date()),
};

const customerColumn: Readonly<Column<StockRowLike>> = { name: 'customer.display_string', label: 'Kunde' };

const remarksColumn: Readonly<Column<StockRowLike>> = {
    name: 'remarks',
    label: 'Bemerkung',
    disableColumnSort: true,
    renderCell: ({ rowData }) => dash(rowData.remarks),
};

/** Columns of the container stock across every site, as the ERP reads it. */
export const containerStockColumns: Readonly<Column<ContainerStockGroup>>[] = [
    customerColumn,
    siteColumn,
    containerTypeColumn,
    containerNumberColumn,
    countColumn,
    contentColumn,
    standingSinceColumn,
    standingForColumn,
    remarksColumn,
];

/** Columns of the lines a group is made of. */
export const containerStockLineColumns: Readonly<Column<ContainerStockRow>>[] = [
    containerNumberColumn,
    billedAsColumn,
    contentColumn,
    standingSinceColumn,
    standingForColumn,
    remarksColumn,
];

/**
 * The same stock in the portal, where every group stands for the one customer reading it and the
 * container types carry the names the operator picked for the portal.
 */
export function portalContainerStockColumns(
    containerTypeOf: (containerType: LinkableField | undefined) => string,
): Readonly<Column<ContainerStockGroup>>[] {
    return [
        {
            ...containerTypeColumn,
            renderCell: ({ rowData }) => dash(containerTypeOf(rowData.container_type)),
        },
        countColumn,
        containerNumberColumn,
        siteColumn,
        standingSinceColumn,
    ];
}
